import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast } from "../../../utils/toasts";

// Takes the program id to activate on the plan, or null to deactivate its current program.
export const useActivatePricingPlanProgram = (planId: number) => {
  const { t } = useTranslation(["programs"]);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (programId: number | null) =>
      await apiClient.activatePricingPlanProgram({ plan_id: planId, program_id: programId }),
    // Awaited, so the mutation stays pending (and callers' optimistic state holds) until the
    // refetched plan arrives. The plan is cached under [{ entity: "pricing_plans" }].
    onSettled: async () =>
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["pricing_plans"] }),
        queryClient.invalidateQueries({ queryKey: [{ entity: "pricing_plans" }] }),
        queryClient.invalidateQueries({ queryKey: ["programs"] }),
      ]),
    onError: (error) => {
      errorToast({ message: t(($) => $.programs.list["Failed to update the active program"]), error });
    },
  });
};
